import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTooltip = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  padding: '8px 12px',
  fontSize: '14px',
  lineHeight: '1.4',
  maxWidth: '300px',
  wordWrap: 'break-word',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  zIndex: 1000,
  pointerEvents: 'none',
}));

export const StyledTooltipLabel = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 'bold',
  marginBottom: '4px',
}));
